import { render } from "./Footer.vue?vue&type=template&id=78ed6b02&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=78ed6b02&scoped=true&lang=css"

import exportComponent from "/Users/jaakkojakara/Documents/Aekosbot/apps/aekosweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ed6b02"]])

export default __exports__